var s = Object.defineProperty;
var i = (t, o, a) => o in t ? s(t, o, { enumerable: !0, configurable: !0, writable: !0, value: a }) : t[o] = a;
var e = (t, o, a) => i(t, typeof o != "symbol" ? o + "" : o, a);
import { BaseEnvironment as m } from "./main6.js";
class c extends m {
  constructor() {
    super(...arguments);
    /**
     * Webmotors base domain
     *
     */
    e(this, "domain", "webmotors.com.br");
    /**
     * Webmotors api URL
     *
     */
    e(this, "apiURL", `https://www.${this.domain}/api`);
    /**
     * Webmotors base URL
     *
     */
    e(this, "baseURL", `https://www.${this.domain}`);
    /**
     * Webmotors private api URL
     *
     */
    e(this, "apiPrivateURL", "https://yur5i9svf7-vpce-0f91c6824aa2e651d.execute-api.us-east-1.amazonaws.com/prd/api");
    /**
     * SEO private api URL
     *
     */
    e(this, "seoApiPrivateURL", "https://sem3hlobfi-vpce-0f91c6824aa2e651d.execute-api.us-east-1.amazonaws.com/prd/api");
    /**
     * Cookie domain
     *
     */
    e(this, "cookieDomain", [this.domain, `.${this.domain}`, `www.${this.domain}`]);
    /**
     * Auth Cookie Name on production environment
     *
     */
    e(this, "authCookieName", "webmotors.jwt.token");
    /**
     * Access Token Cookie Name on production environment
     *
     */
    e(this, "accessTokenCookieName", "webmotors.access.token");
    /**
     * Refresh Token Cookie Name on production environment
     *
     */
    e(this, "refreshTokenCookieName", "webmotors.refresh.token");
    /**
     * Vehicle photo path on PROD environment
     *
     */
    e(this, "photoPath", "https://image.webmotors.com.br");
    /**
     * Webmotors chat api websocket URL
     *
     */
    e(this, "chatApiUrl", "wss://chat.webmotors.com.br");
    /**
     * Adobe SDK path
     *
     */
    e(this, "adobeSDK", "https://assets.adobedtm.com/0a9348ad03c2/c7e2a344c6e9/launch-3d19ca046842.min.js");
    /**
     * Hot deal image path on PROD environment
     *
     */
    e(this, "hotDealImage", "https://image.webmotors.com.br/feiroes/imagens/prd/_portal/");
    /**
     * Seller shield image path
     */
    e(this, "sellerShieldImage", "https://webmotors.com.br/img/blindagem/");
    /**
     * Login route
     *
     */
    e(this, "loginRoute", `https://www.${this.domain}/login`);
  }
}
export {
  c as ProductionEnvironment
};
